import { render, staticRenderFns } from "./PressResults.vue?vue&type=template&id=3417772f&scoped=true"
import script from "./PressResults.vue?vue&type=script&lang=js"
export * from "./PressResults.vue?vue&type=script&lang=js"
import style0 from "./PressResults.vue?vue&type=style&index=0&id=3417772f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3417772f",
  null
  
)

export default component.exports